module.exports = __webpack_public_path__ + "media/public/img/getyourguide-review-widget-01-c9ff127aecadc9be5c96765474840e58.svg";